const routes = [{
  path: '/',
  load: () => import(/* webpackChunkName: 'login' */ './login'),
}, {
  path: '/mail',
  load: () => import(/* webpackChunkName: 'maillogin' */ './mailLogin'),
}]

export default routes



// WEBPACK FOOTER //
// ./src/routes/login/index.js